import { render, staticRenderFns } from "./assistances.component.vue?vue&type=template&id=6c965cb0&"
import script from "./assistances.component.vue?vue&type=script&lang=ts&"
export * from "./assistances.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assistances.component.vue"
export default component.exports